import { AuthService, type LoginBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: LoginBodyDto;
};

export const login = ({ call, requestBody }: TParams) =>
  call(() => AuthService.login({ requestBody }), { dontCatchErrors: true });
